/* eslint-disable react/no-array-index-key */
/* eslint-disable react/require-default-props */

import React from 'react';

import { convertV1toV2Table } from 'reports/utils';

import ReportTableV2 from './ReportTableV2';

class ReportTableConventer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const propsToPass = /* this.props.convertTo === 'v2' */ convertV1toV2Table(this.props.data);
    return (
      <ReportTableV2
        data={propsToPass}
        title={this.props.title}
        startDate={this.props.startDate}
        endDate={this.props.endDate}
      />
    );
  }
}

export default ReportTableConventer;
